(function($) {
  $(".highlights-carousel")
    .not(".slick-initialized")
    .slick({ dots: true });

  $(".listing-gallery")
    .not(".slick-initialized")
    .slick({ dots: true, arrows: false });
  //anything
  $(".gallery").slick({
    slidesToShow: 4,
    slidesToScroll: 4,
    // centerMode: true,
    responsive: [
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  });

  $(".listing-gallery").each(function(i, gallery) {
    $(gallery).featherlightGallery({
      previousIcon: "«",
      nextIcon: "»",
      galleryFadeIn: 300,
      openSpeed: 300,
      filter: "a",
      afterContent: function() {
        var altText = this.$currentTarget.attr('data-featherlight-alt');
        this.$instance.find('.featherlight-image').attr('alt',altText);
      }
    });
  });

  $(".gallery a").featherlightGallery({
    previousIcon: "«",
    nextIcon: "»",
    galleryFadeIn: 300,
    openSpeed: 300,
    afterContent: function() {
      var altText = this.$currentTarget.attr('data-featherlight-alt');
      this.$instance.find('.featherlight-image').attr('alt',altText);
    }
  });

  $(".select-go").on("change", function(e) {
    if ($(this).val()) {
      window.location = $(this).val();
    }
  });

  $('.clear-filters').on('click tap touch',function(e){
    e.preventDefault();
    $('.resultsbar-tag .fa').trigger('click');
  });

})(jQuery);
